class ConfiguratorHeadboards {
    constructor() {
        this.id = 'headboards';
        this.cache = {};
        this.items = {};

        this.selectors = [
            'headboards'
        ];

        configurator.addSelectorItem(this.id);
        this.init();
    }

    async init() {
    }

    isValidSelector(selector) {
        return this.selectors.includes(selector);
    }

    setupListeners() {
    }

    /**
     * Headboard width to use for a given headboard category and mattress width.
     * Frames that are wider than the mattress (Hallsö Upholstery / Walnut) need wider
     * headboards, e.g. a 180x200 mattress takes a 186 wide Rivö. Configured per template
     * through the "Headboard Width Overrides" section setting. Falls back to the mattress
     * width, which is the rule for every other bed.
     */
    getTargetWidth(category, mattress_width) {
        const width_map = bed_configuration.headboard_width_map || {};
        return width_map[category]?.[mattress_width] ?? mattress_width;
    }

    substituteWithValidProduct(){
        let split_base = configurator.selection[this.id].split('_');
        var categoryName = split_base[0];
        var selectedHeadBoardSize = split_base.length > 0 ? configurator.selection[this.id].split('_')[1] : null;
        if(categoryName){
            let items = Object.values(this.items);
            let anotherInSameCategory = null;
            if(selectedHeadBoardSize && (categoryName.includes('pinno') || categoryName.includes('ottero'))){                
                var categoryWithoutUk = categoryName.replace('uk', '').replace('salo', '');
                
                var headboardWidth =  parseInt(selectedHeadBoardSize.split('x')[0]);
                var selectedHeadboardWidth = headboardWidth;
                if(headboardWidth > 218){
                    selectedHeadboardWidth = headboardWidth - 96;                    
                }
                var selectedWidth = parseInt(configurator.selection.size.split('x')[0]);
                var widthOfReplacement = configurator.pinnoOtteroNavigator[categoryWithoutUk][headboardWidth.toString()][selectedWidth > selectedHeadboardWidth ? 'up' : 'down'];
                if(widthOfReplacement){
                    anotherInSameCategory = items.find(item => item.id.split('_')[0] == categoryName && item.size.split('x')[0] == widthOfReplacement);
                    if(!anotherInSameCategory){
                        widthOfReplacement = configurator.pinnoOtteroNavigator[categoryWithoutUk][widthOfReplacement][selectedWidth > selectedHeadboardWidth ? 'up' : 'down'];
                        anotherInSameCategory = items.find(item => item.id.split('_')[0] == categoryName && item.size.split('x')[0] == widthOfReplacement);
                    }
                }
                
            }else{
                items.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
                anotherInSameCategory = items.find(item => item.id.includes(categoryName));
            }
            
            configurator.selection[this.id] = anotherInSameCategory?.id || null;
            console.log('Substituted with ', anotherInSameCategory?.id);
        }else{
            configurator.selection[this.id] = null;
        }

    }
    async refresh(selector) {
        if (configurator.selection.size == null || configurator.selection.fabric == null) {
            configurator.resetSelectorData( this.id );
            return;
        }
        if (!(configurator.selection.size in this.cache) || !(configurator.selection.fabric in this.cache[configurator.selection.size])) {
            await this.loadItems(configurator.selection.size, configurator.selection.fabric);
        }

        this.populateItems();
    }

    async loadItems(size, fabric) {
        const size_arr = size.split('x');
        const size_key = size_arr[0]+'x'; // width only
        let width = parseInt(size_arr[0]); // width only (in cm)
        const is_double = width > 140 ? true : false;

        // Check if already loaded
        if (size_key in this.cache && fabric in this.cache[size_key].fabrics) {
            return;
        }

        // Init data object
        if (!(size_key in this.cache)) {
            this.cache[size_key] = { 'title': size_key, 'fabrics': {} };
        }
        this.cache[size_key].fabrics[fabric] = { 'title': fabric, 'products': {} };

        // Init GraphQL filter object
        const filters = [
            {key: 'fabric', value: fabric},
            {key: 'fabric', value: '0WALN'}, // Include Walnut products with no fabric
        ];

        // Add bedframe margin - TODO: M3 adjustment? - 180 size beds have 6 cm extra, other beds 8 cm extra?
        const originalWidthCm = width; // Store the initial width, assuming it's in cm
        const SCALE_FACTOR = 10; // Used to scale cm to mm for filters

        const BED_TYPE_BEDFRAME = 'bedframe';

        const BEDFRAME_MARGIN_CM_FOR_180 = 6;
        const BEDFRAME_MARGIN_CM_DEFAULT = 8;

        // Helper function to add a width filter after scaling
        const addScaledWidthFilter = (wCm) => {
            filters.push({ key: 'width', value: wCm * SCALE_FACTOR });
        };

        // 1. Add the base bed width filter (using the original width)
        addScaledWidthFilter(originalWidthCm);

        let currentWidthForLogic = originalWidthCm;

        // 2. Handle adjustments and filters if the bed type is "bedframe"
        if (bed_configuration.type === BED_TYPE_BEDFRAME) {
            const marginToAdd = (originalWidthCm === 180) ? BEDFRAME_MARGIN_CM_FOR_180 : BEDFRAME_MARGIN_CM_DEFAULT;
            currentWidthForLogic = originalWidthCm + marginToAdd;
            addScaledWidthFilter(currentWidthForLogic); // Add filter for the width including the frame margin
                                                        // The original comment "Add size without margins for Rixö" was for this push,
                                                        // but it actually adds the size WITH margins. The first filter is without margins.
        }

        if (currentWidthForLogic === 180) {
            addScaledWidthFilter(186);
        }

        if (currentWidthForLogic >= 210) {
            addScaledWidthFilter(218);
            addScaledWidthFilter(216);
            addScaledWidthFilter(312);
        }

        if (currentWidthForLogic === 150 || currentWidthForLogic === 158) {
            addScaledWidthFilter(156);
            addScaledWidthFilter(252);
        }

        if (currentWidthForLogic >= 180) {
            addScaledWidthFilter(282);
        } else if (currentWidthForLogic === 150) {
            addScaledWidthFilter(158);
        }

        // Make sure the overridden headboard widths are fetched, even if none of the
        // margin rules above happen to cover them
        const headboard_width_map = bed_configuration.headboard_width_map || {};
        for (const category in headboard_width_map) {
            const mapped_width = headboard_width_map[category][originalWidthCm];
            if (mapped_width) { addScaledWidthFilter(mapped_width); }
        }

        // Load data from Shopify
        const products = await configurator.loadProductData('configurator-'+this.id, filters, ['size']);

        // Load data from Shopify - build special Skärgård 0x0 product
        const products_skargaard = await configurator.loadProductData('configurator-'+this.id, [
            {key: 'category', value: 'skargard'},
            {key: 'category', value: 'skargarduk'},
            {key: 'fabric', value: fabric},
            {key: 'size', value: '90x135'}, // Skärgård
        ], ['size']);

        // Populate items
        const all_products = [...products, ...products_skargaard];
        // Find duplicate IDs in all_products
        const idCounts = {};
        for (const product of all_products) {
            if (!product.category) continue;
            idCounts[product.category] = (idCounts[product.category] || 0) + 1;
        }
        const duplicateIds = Object.keys(idCounts).filter(category => idCounts[category] >= 2);
        for (const product of all_products) {
            // Skip products with price 0 when e-commerce is enabled
            if (product.variants[0].price == 0 && configurator.enable_ecommerce == true) { 
                console.log(`❌ Skipping ${product.productid} - price is 0 and e-commerce enabled`);
                continue; 
            }

            // Skip if the primary variant's SKU is globally excluded (takes precedence)
            if (bed_configuration.excluded_skus_global_set && (bed_configuration.excluded_skus_global_set.has(product.variants[0].sku) || bed_configuration.excluded_skus_global_set.has(product.category))) {
                console.log(`❌ Headboard SKU ${product.variants[0].sku} or category ${product.category} for product ${product.productid} excluded globally.`);
                continue;
            }

            const skus = [];
            const ids = [];
            const arr = product.size.split('x');
            let price = 0;

            /* =========================================================================
               SPECIAL CASE: Exclude Otterosalo 282 for large frames
               ========================================================================= */               
            if (currentWidthForLogic >= 210) {                
                const is282 = parseInt(arr[0]) === 282;
                const isOttero = product.productid.includes('ottero');
                if (is282 && isOttero) {
                    console.log(`❌ Skipping ${product.productid} - Otterosalo 282 disallowed for bed width ${currentWidthForLogic}cm`);
                    continue;
                }
            }

            // Include/exclude headboards
            if (bed_configuration.available_headboards.length > 0 && !bed_configuration.available_headboards.includes(product.category)) { 
                console.log(`❌ Skipping ${product.productid} - category ${product.category} not in available headboards list`);
                continue; 
            }
            if (bed_configuration.exclude_headboards.length > 0 && bed_configuration.exclude_headboards.includes(product.category)) { 
                console.log(`❌ Skipping ${product.productid} - category ${product.category} is in exclude headboards list`);
                continue; 
            }

            //if (bed_configuration.type == "bedframe" && product.category == 'rivo' && arr[0] == width) { continue; } // Only Rivö comes in +6 cm sizes

            // Find Reference Product parent
            if(!configurator.applyReferenceProduct(product)){
                continue;
            }

            // Bornö left and right have to match length of bed
            if (product.productid.includes('bornol') || product.productid.includes('bornor')) {
                if (arr[1] != size_arr[1]) {
                    continue;
                }
            }

            // Convert to available sizes in Cylindo and compile Product Thumbnail
            let size_w = '180';
            if (['80', '90', '105'].includes(arr[0])) { size_w = '90'; }
            if (['120', '140'].includes(arr[0])) { size_w = '140'; }
            if (['160', '180', '210'].includes(arr[0])) { size_w = '180'; }
            if (['282'].includes(arr[0])) { size_w = '282'; }
            if (product.productid.includes("bornol") && arr[0] == '120') { size_w = '120'; } // Lille Bornö model is 120 only (no 140)
            if (product.productid.includes("bornor") && arr[0] == '120') { size_w = '120'; } // Lille Bornö model is 120 only (no 140)

            let size_h = arr[1];
            if (size_h == '107') { size_h = '120'; }
            if (size_h == '186') { size_h = '180'; }
            if (size_h == '210') { size_h = '200'; }

            let cylindo_size = size_h + 'x' + size_w;
            if (product.productid.includes("bornol")) { cylindo_size += " LEFT"; }
            if (product.productid.includes("bornor")) { cylindo_size += " RIGHT"; }
            let cylindo_fabric = configurator.m3_fabrics[fabric][0];

            // === SKÄRGÅRD HEADBOARD PROCESSING ===
            if (product.productid.includes('skargard')) { 
                cylindo_size = '135X270 (3X3 MODULS)'; 
            }
            
            // === TORNÖ HEADBOARD PROCESSING ===
            else if (product.productid.includes('torno')) {
                cylindo_size = ''; 
            }
            
            // === PINNÖ HEADBOARD PROCESSING ===
            else if (product.productid.includes('pinno')) {                
                cylindo_size = arr[0];
                if (cylindo_size == '282') {
                    cylindo_size += ' CM ' + (product.original_id?.includes('st') ? 'WITH' : 'WITHOUT') + ' SIDE TABLE';
                    if (!product.original_id?.includes('salo')) {
                        cylindo_size += ' NO PANEL';
                        cylindo_fabric = '';
                    }else{
                        cylindo_size += ' WITH 181,5 PANEL';
                    }
                } else {
                    if (product.original_id && product.original_id.includes('salo')) {
                        // It's Salo-related (e.g., "Pinnö with Sälö 158x149"), so use fabric
                        cylindo_fabric = configurator.m3_fabrics[fabric][0];
                    } else {
                        // It's NOT Salo-related (e.g., "Pinnö 158x149"), so no fabric feature
                        cylindo_fabric = '';
                    }
                }
            }
            
            // === OTTERO HEADBOARD PROCESSING ===
            else if (product.productid.includes('ottero')) {
                product.cylindo_model = 'FULL WALNUT HEADBOARD'; 

                cylindo_size = arr[0];
                if (!product.original_id?.includes('salo')) { 
                    // If it's a plain Ottero not associated with Salo, clear the fabric feature for Cylindo.
                    cylindo_fabric = '';
                }

            }
            
            // === RIXÖ HEADBOARD PROCESSING ===
            else if (product.productid.includes('rixo')) {
                cylindo_size = (arr[0] / 2) + 'x55 x 2';
            }

            const thumbnail = bed_configuration.cylindo_base_url + product.cylindo_model + '/frames/3/' + product.cylindo_model + '.jpg?'
                + (cylindo_size != '' ? '&feature=SIZE:'+cylindo_size : '')
                + (cylindo_fabric != '' ? '&feature=UPHOLSTERY:'+cylindo_fabric : '')
                +'&size=512&background=f7f7f7&encoding=jpg';

            // === HEADBOARD TYPE SPECIFIC PROCESSING AND SKU/ID ASSIGNMENT ===
            if (product.productid.includes('skargard')) {
                if (is_double) {
                    // Build 3 x 3 configuration and match beds from size 150 and up
                    for (var i = 0; i < 3; i++) {
                        skus.push(product.variants[0].sku);
                        ids.push(product.variants[0].id.replace('gid://shopify/ProductVariant/', ''));
                    };
                    price = 3 * product.variants[0].price;
                }

            } else if (product.productid.includes('pinno') || product.productid.includes('ottero')) {
                skus.push(product.variants[0].sku);
                ids.push(product.variants[0].id.replace('gid://shopify/ProductVariant/', ''));
                price = product.variants[0].price;
                product.uniqueProductKey = `${product.category}_${arr[0]}x${arr[1]}${product.original_id.endsWith('st') ? 'st' : ''}`;
                
            } 
            else if (parseInt(arr[0]) == this.getTargetWidth(product.category, width)) {
                // Anything but Skärgård and Pinnö 282 must match in width
                skus.push(product.variants[0].sku);
                ids.push(product.variants[0].id.replace('gid://shopify/ProductVariant/', ''));
                price = product.variants[0].price;
            }

            // === FINAL CACHE STORAGE ===
            if (skus.length > 0) {
                // Create unique cache key combining product ID and size to prevent overwrites
                let uniqueProductKey = product.uniqueProductKey || product.productid; //product.productid.replace(/(\d+x\d+)$/, '_$1');
                if(this.cache[size_key].fabrics[fabric].products[uniqueProductKey] || duplicateIds.includes(uniqueProductKey)){
                    uniqueProductKey = `${product.productid}_${arr[0]}x${arr[1]}`;
                }
                this.cache[size_key].fabrics[fabric].products[uniqueProductKey] = {
                    'id': uniqueProductKey, // Use unique key as ID for proper selection
                    'handle': product.handle,
                    'label': this.generateHeadboardLabel(product, arr),
                    'ids': ids,
                    'skus': skus,
                    'price': price,
                    'thumbnail': thumbnail,
                    'available': product.variants[0].availableForSale,
                    'original_product_id': product.productid, // Keep original for reference
                    'size': `${arr[0]}x${arr[1]}`, // Store size for reference
                }
                // TEST if (product.productid == 'pinno186x149') this.cache[size_key].fabrics[fabric].products[uniqueProductKey].available = false;
            }            
        }
    }



    generateHeadboardLabel(product, sizeArray) {
        // If the title already includes an x, return it as is
        if(product.title.includes('x')){return product.title;}

        // Only target ottero and otterosalo products
        const isOttero = product.productid.includes('ottero') && !product.productid.includes('salo');
        const isOtteroSalo = product.productid.includes('otterosalo');
        const isPinno = product.productid.includes('pinno') && !product.productid.includes('salo');
        const isPinnoSalo = product.productid.includes('pinnosalo');
        
        if ((isOttero || isOtteroSalo || isPinnoSalo || isPinno) && sizeArray && sizeArray.length >= 2) {
            const size = `${sizeArray[0]}x${sizeArray[1]}`;
            return `${product.title} ${size}` + (product.uniqueProductKey.includes('st') ? ' ST' : '');
        }
        
        return product.title;
    }

    populateItems() {
        const size_key = configurator.selection.size.split('x')[0]+'x'; // width only

        let fabric = configurator.selection.fabric;
        this.items = this.cache[size_key].fabrics[fabric].products;
        let items = Object.values(this.items);
        configurator.renderSelector(this.id, items, {
            'thumbnails': true,
            'columns': 3,
        });
    }

    isSoldOut() {
        return false;
    }

    getPriceData(priceData) {
        // Find the item using the selection key, which might be either the old format or new unique format
        let item = this.items[configurator.selection.headboards];
        
        // If not found with direct key, try to find by original product ID
        if (!item && configurator.selection.headboards) {
            // Look for items that match the selected headboard ID (handling both old and new cache formats)
            for (const [key, value] of Object.entries(this.items)) {
                if (key === configurator.selection.headboards || 
                    value.original_product_id === configurator.selection.headboards ||
                    value.id === configurator.selection.headboards) {
                    item = value;
                    break;
                }
            }
        }

        if (item != null) {
            priceData.total += item.price ?? 0;
            priceData.skus.push(...item.skus);
            priceData.ids.push(...item.ids);
        }
    }

    getCylindoSpecs(specs) {
        // ============== Translate Headboard config ==============
        if (configurator.selection.headboards == null) {
            specs.features['HEADBOARD TYPE'] = 'OFF';
            return;
        }

        // Get the selected headboard ID (handle both old and new cache key formats)
        let selectedHeadboardId = configurator.selection.headboards;
        
        // Get the selected headboard item to access size information
        let selectedItem = this.items[configurator.selection.headboards];
        
        // If not found with direct key, try to find by original product ID
        if (!selectedItem && configurator.selection.headboards) {
            for (const [key, value] of Object.entries(this.items)) {
                if (key === configurator.selection.headboards || 
                    value.original_product_id === configurator.selection.headboards ||
                    value.id === configurator.selection.headboards) {
                    selectedItem = value;
                    break;
                }
            }
        }
        
        // If using new unique cache format, extract the original product ID
        if (selectedHeadboardId && this.items[selectedHeadboardId] && this.items[selectedHeadboardId].original_product_id) {
            selectedHeadboardId = this.items[selectedHeadboardId].original_product_id;
        }

        // Extract width from selected item's size property (format: "WIDTHxHEIGHT") for dynamic sizing
        let dynamicWidth = '';
        if (selectedItem && selectedItem.size) {
            const sizeArray = selectedItem.size.split('x');
            if (sizeArray.length > 0) {
                dynamicWidth = sizeArray[0];
            }
        }

        if (selectedHeadboardId.includes('lillabornol')) specs.features['HEADBOARD TYPE'] = 'LILLA BORNO';
        else if (selectedHeadboardId.includes('lillabornor')) specs.features['HEADBOARD TYPE'] = 'LILLA BORNO';
        else if (selectedHeadboardId.includes('borno')) specs.features['HEADBOARD TYPE'] = 'BORNO';
        else if (selectedHeadboardId.includes('skargard')) specs.features['HEADBOARD TYPE'] = 'SKARGAARD';
        else if (selectedHeadboardId.includes('lowtorno')) specs.features['HEADBOARD TYPE'] = 'LOW TORNO';
        else if (selectedHeadboardId.includes('torno')) specs.features['HEADBOARD TYPE'] = 'TORNO';
        else if (selectedHeadboardId.includes('rivo')) specs.features['HEADBOARD TYPE'] = 'RIVO';
        else if (selectedHeadboardId.includes('vallero')) specs.features['HEADBOARD TYPE'] = 'VALLERO';
        else if (selectedHeadboardId.includes('solo') && selectedHeadboardId.includes('low')) specs.features['HEADBOARD TYPE'] = 'SOLO 107';
        else if (selectedHeadboardId.includes('solo') && selectedHeadboardId.includes('high')) specs.features['HEADBOARD TYPE'] = 'SOLO 120';
        else if (selectedHeadboardId.includes('ango')) specs.features['HEADBOARD TYPE'] = 'ANGÖ';
        else if (selectedHeadboardId.includes('pinno')){
            if (dynamicWidth === '158') { dynamicWidth = '186'; } // we sell 158 sized headboards, but it's too expensive to render, so we just show the 186 sized headboard
            if (dynamicWidth === '218') { dynamicWidth = '282'; }
            var supportSideTable = dynamicWidth < 282 ? '' : ` WITH${selectedItem.id.includes('st')?'':'OUT'} SIDE TABLE`;
            specs.features['HEADBOARD TYPE'] = `PINNO ${dynamicWidth} CM${supportSideTable}`;
            if (selectedHeadboardId.includes('salo')) {
                specs.features['HEADBOARD TYPE'] += ' WITH SALO';
            }
        }
        else if (selectedHeadboardId.includes('rixo')) specs.features['HEADBOARD TYPE'] = 'RIXO';
        else if (selectedHeadboardId.includes('ottero'))
        {
            if (dynamicWidth === '156') { dynamicWidth = '186'; }
            if (dynamicWidth === '252' || dynamicWidth === '216' || dynamicWidth === '312') { dynamicWidth = '282'; }
            specs.features['HEADBOARD TYPE'] = 'OTTERO WALNUT ' + dynamicWidth + ' CM';
            if (selectedHeadboardId.includes('salo')) {
                specs.features['HEADBOARD TYPE'] += ' WITH SALO';
            }
        }

        //if (configurator.selection.headboards.includes('pinno_282x149')) specs.features['HEADBOARD TYPE'] = 'PINNO 282 CM WITHOUT SIDE TABLE';
        //if (configurator.selection.headboards.includes('pinno_282x149st')) specs.features['HEADBOARD TYPE'] = 'PINNO 282 CM WITH SIDE TABLE';
    }
}